import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getInvoiceReconciliationAmount } from 'Utils/reconciliation';
import { useTranslation } from 'react-i18next';
import { useQueries } from '@tanstack/react-query';
import { getInvoice } from 'Services/invoices';
import ReconciliationTransactionsInvoiceAsync from './ReconciliationTransactionsInvoiceAsync';

export default function ReconciliationSelectedInvoices({ invoicesIds, onDeleteInvoice, onChangeTotal, showEmptyPlaceholder = true }) {
    const [amounts, setAmounts] = useState({});
    const { t } = useTranslation('reconciliation');

    const invoicesQueries = useQueries({
        queries: invoicesIds.map((id) => ({
            queryKey: ['invoices', id],
            queryFn: () => getInvoice(id),
            enabled: invoicesIds.length > 0,
        })),
    });

    useEffect(() => {
        const newAmounts = {};
        invoicesQueries.forEach((query, index) => {
            if (query.data?.amount_uc != null) {
                newAmounts[invoicesIds[index]] = getInvoiceReconciliationAmount(query.data);
            }
        });
        setAmounts(newAmounts);
    }, [invoicesQueries.map((q) => q.data?.amount_uc).join(',')]);

    useEffect(() => {
        const total = Object.values(amounts).reduce((sum, amount) => sum + (amount || 0), 0);
        onChangeTotal(total);
    }, [amounts, onChangeTotal]);

    if (invoicesIds.length === 0) {
        if (!showEmptyPlaceholder) return null;
        return (
            <div className="relative h-[62px] flex justify-center items-center text-center rounded-md border-dashed border border-gray-300 bg-gray-50 text-xs text-gray-500">
                {t('click-invoice-to-add')}
            </div>
        );
    }

    return (
        <div className="grid gap-1">
            {invoicesIds.map((invoiceId) => (
                <div key={invoiceId} className="border border-dark-blue/10 rounded-md px-4 py-3">
                    <ReconciliationTransactionsInvoiceAsync
                        invoiceId={invoiceId}
                        onDelete={() => onDeleteInvoice(invoiceId)}
                    />
                </div>
            ))}
        </div>
    );
}

ReconciliationSelectedInvoices.propTypes = {
    invoicesIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    onDeleteInvoice: PropTypes.func.isRequired,
    onChangeTotal: PropTypes.func.isRequired,
    showEmptyPlaceholder: PropTypes.bool,
};
